import {
    DMARC_AUTHENTICATION_FAILURE,
    DMARC_AUTHENTICATION_REQUEST,
    DMARC_AUTHENTICATION_SUCCESS,
} from '../actions/types/dmarc-authentication-action-types';
import {
    DMARC_EFFECTIVENESS_FAILURE,
    DMARC_EFFECTIVENESS_REQUEST,
    DMARC_EFFECTIVENESS_SUCCESS,
} from '../actions/types/dmarc-effectiveness-action-types';
import {
    DOMAIN_COVERAGE_FAILURE,
    DOMAIN_COVERAGE_REQUEST,
    DOMAIN_COVERAGE_SUCCESS,
} from '../actions/types/domain-coverage-action-types';
import {
    MESSAGE_VOLUME_COVERAGE_FAILURE,
    MESSAGE_VOLUME_COVERAGE_REQUEST,
    MESSAGE_VOLUME_COVERAGE_SUCCESS,
} from '../actions/types/message-volume-coverage-action-types';

import { combineReducers } from 'redux';

function authentication( state = {}, action ){
    let newState;
    switch( action.type ){
        case DMARC_AUTHENTICATION_SUCCESS:
            newState = action.payload;
            break;
        case DMARC_AUTHENTICATION_REQUEST:
            newState = {};
            break;
        default:
            return state;
    }

    return newState;
}

function authenticationParams( state = {}, action ){
    let newState = state;
    switch( action.type ){
        case DMARC_AUTHENTICATION_REQUEST:
            newState = action.params || {};
            break;
        default:
            return state;
    }

    return newState;
}

function authenticationIsLoading( state = false, action ){
    let newState;
    switch( action.type ){
        case DMARC_AUTHENTICATION_REQUEST:
            newState = true;
            break;
        case DMARC_AUTHENTICATION_SUCCESS:
        case DMARC_AUTHENTICATION_FAILURE:
            newState = false;
            break;
        default:
            return state;
    }

    return newState;
}

function effectiveness( state = {}, action ){
    let newState;
    switch( action.type ){
        case DMARC_EFFECTIVENESS_SUCCESS:
            newState = action.payload;
            break;
        case DMARC_EFFECTIVENESS_REQUEST:
            newState = {};
            break;
        default:
            return state;
    }

    return newState;
}

function effectivenessParams( state = {}, action ){
    let newState = state;
    switch( action.type ){
        case DMARC_EFFECTIVENESS_REQUEST:
            newState = action.params || {};
            break;
        default:
            return state;
    }

    return newState;
}

function effectivenessIsLoading( state = false, action ){
    let newState;
    switch( action.type ){
        case DMARC_EFFECTIVENESS_REQUEST:
            newState = true;
            break;
        case DMARC_EFFECTIVENESS_SUCCESS:
        case DMARC_EFFECTIVENESS_FAILURE:
            newState = false;
            break;
        default:
            return state;
    }

    return newState;
}

function domainCoverage( state = {}, action ){
    let newState;
    switch( action.type ){
        case DOMAIN_COVERAGE_SUCCESS:
            newState = action.payload;
            break;
        case DOMAIN_COVERAGE_REQUEST:
            newState = {};
            break;
        default:
            return state;
    }

    return newState;
}

function domainCoverageParams( state = {}, action ){
    let newState = state;
    switch( action.type ){
        case DOMAIN_COVERAGE_REQUEST:
            newState = action.params || {};
            break;
        default:
            return state;
    }

    return newState;
}

function domainCoverageIsLoading( state = false, action ){
    let newState;
    switch( action.type ){
        case DOMAIN_COVERAGE_REQUEST:
            newState = true;
            break;
        case DOMAIN_COVERAGE_SUCCESS:
        case DOMAIN_COVERAGE_FAILURE:
            newState = false;
            break;
        default:
            return state;
    }

    return newState;
}

function messageVolumeCoverage( state = {}, action ){
    let newState;
    switch( action.type ){
        case MESSAGE_VOLUME_COVERAGE_SUCCESS:
            newState = action.payload;
            break;
        case MESSAGE_VOLUME_COVERAGE_REQUEST:
            newState = {};
            break;
        default:
            return state;
    }

    return newState;
}

function messageVolumeCoverageParams( state = {}, action ){
    let newState = state;
    switch( action.type ){
        case MESSAGE_VOLUME_COVERAGE_REQUEST:
            newState = action.params || {};
            break;
        default:
            return state;
    }

    return newState;
}

function messageVolumeCoverageIsLoading( state = false, action ){
    let newState;
    switch( action.type ){
        case MESSAGE_VOLUME_COVERAGE_REQUEST:
            newState = true;
            break;
        case MESSAGE_VOLUME_COVERAGE_SUCCESS:
        case MESSAGE_VOLUME_COVERAGE_FAILURE:
            newState = false;
            break;
        default:
            return state;
    }

    return newState;
}

export default combineReducers( {
    authentication,
    authenticationIsLoading,
    authenticationParams,
    domainCoverage,
    domainCoverageIsLoading,
    domainCoverageParams,
    effectiveness,
    effectivenessIsLoading,
    effectivenessParams,
    messageVolumeCoverage,
    messageVolumeCoverageIsLoading,
    messageVolumeCoverageParams,
} );
